module.exports = "/assets/e8d257b9e8c39ebb4bf3da1a6624be78.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/Y5.png
// module id = 3135
// module chunks = 0